import { IConfigurationRegistry } from "../../../../base/domain/configuration";
import { IConfiguration } from "../../../domain/configuration";
import { EditableFormatSummary, IEditableFormatRepositoryBase } from "../../../domain/editableFormat";
import { IEditableFormatBean } from "./beans";
import { EditableFormatTreeRepository } from "./EditableFormatTreeRepository";

export class EditableFormatRepositoryBase extends EditableFormatTreeRepository implements IEditableFormatRepositoryBase {
  constructor(getToken: () => string, _configurationRegistry: IConfigurationRegistry<IConfiguration>, _treePath?: string) {
    super(getToken, _configurationRegistry, _treePath);
  }

  async getFormat(id: number): Promise<EditableFormatSummary> {
    const url = "api/format-editor/format/" + id;
    const result = await this.get<IEditableFormatBean>(url);
    return this._translatorFactory.create().toFormat(() => this.token, result.data);
  }

  async getFormatArchives(id: number): Promise<EditableFormatSummary[]> {
    const url = "api/format-editor/format/" + id + "/archives";
    const result = await this.get<IEditableFormatBean[]>(url);
    return this._translatorFactory.create().toFormats(() => this.token, result.data);
  }

  async redisplayFormat(id: number, parent: number): Promise<void> {
    const url = "api/format-editor/" + this._treePath + "/redisplay-format";
    const query = {
      formatId: id,
      parentId: parent,
    };
    await this.post<void>(url, query);
  }
}
